import { Component, OnInit } from '@angular/core';
import { GrievanceDashboardService } from '../grievance-dashboard.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-grievance-landing-page',
  templateUrl: './grievance-landing-page.component.html',
  styleUrls: ['./grievance-landing-page.component.scss']
})
export class GrievanceLandingPageComponent implements OnInit {
  isCollapsed: boolean = false;
  isContainerCollapsed: boolean = true;

  containerWidth = '';

  activeView = 'grievance';
  roleDetails: any;

  Grievanceuser1 = false;
  Grievanceuser2 = false;
  constructor(private Service: GrievanceDashboardService, private spinner: NgxSpinnerService,) { }

  ngOnInit(): void {

    this.Service.collapsed$.subscribe(state => {
      this.isCollapsed = state;
    });

    this.Service.width$.subscribe(width => {
      this.containerWidth = width;
    });

    this.Service.view$.subscribe(view => {
      this.activeView = view;
    });

  }


}
